import { Injectable } from '@angular/core'
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router'
import { Observable, of } from 'rxjs'
import { SecurityQuestionService } from '../../../api/services/security-question.service'
import { DataPageOfSecurityQuestions } from '../../../api/models/data-page-of-security-questions'
import { catchError } from 'rxjs/operators'
//import {SecurityQuestions} from "../../../api/models/security-questions";

@Injectable({
  providedIn: 'root',
})
export class QuestionAnswerResolverService {
  constructor(private questionService: SecurityQuestionService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<DataPageOfSecurityQuestions> {
    return this.questionService
      .securityQuestionGetAll({ pageNumber: 1, pageSize: 100000 })
      .pipe(
        catchError((err) => {
          //     create error handler here
          console.log(err)
          return of(null)
        }),
      )
  }
}
